import SiteHeader from '../components/SiteHeader';
import demoSchedules from '../data/demoSchedules.json';

function formatWhen(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso;
  }
}

export default function SchedulesPage() {
  return (
    <div className="site-page site-page-app">
      <SiteHeader variant="app" />
      <div className="demo-banner">
        Dummy schedules — real GIS Liberty can run models on a recurring timetable.
      </div>

      <main className="demo-page">
        <header className="demo-page-head">
          <div>
            <h1>Schedules</h1>
            <p className="field-hint">Automate custom models and algorithms on a calendar.</p>
          </div>
          <button type="button" className="btn btn-primary" disabled title="Demo only">
            New schedule
          </button>
        </header>

        <div className="schedules-grid">
          {demoSchedules.map((sched) => (
            <article key={sched.id} className={`panel-card schedule-card${!sched.enabled ? ' is-disabled' : ''}`}>
              <div className="schedule-card-head">
                <h2>{sched.name}</h2>
                <span className={`status-badge ${sched.enabled ? 'status-completed' : 'status-pending'}`}>
                  {sched.enabled ? 'enabled' : 'paused'}
                </span>
              </div>
              <p className="schedule-model">{sched.modelName}</p>
              <dl className="schedule-meta">
                <div>
                  <dt>Cadence</dt>
                  <dd>{sched.cronLabel}</dd>
                </div>
                <div>
                  <dt>Last run</dt>
                  <dd>{formatWhen(sched.lastRun)} · {sched.lastStatus}</dd>
                </div>
                <div>
                  <dt>Next run</dt>
                  <dd>{formatWhen(sched.nextRun)}</dd>
                </div>
              </dl>
              <p className="field-hint">Cron: <code>{sched.cron}</code></p>
            </article>
          ))}
        </div>
      </main>
    </div>
  );
}
